import gql from "graphql-tag"

export const GET_ACTIVITY_BY_ID = gql`
  query GET_ACTIVITY_BY_ID($id: ID!) {
    objectivesAndActivitiesTabActivity(id: $id) {
      id
      goal
      products
      months
      monthlyAverage
      meansOfVerificationPerMonth {
        id
        month
        year
        monthProgress
        excessProgress
        isRevisionBlocked
        verificationDocumentsPerMonth {
          id
          url
          name
          type
        }
      }
    }
  }
`
